// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonMainPage_button__QVsLx"};